import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/styles";
import { Box, Typography, Button } from "@material-ui/core";
import SubmitButton from "../../submit-button/SubmitButton";
import { SEND_EMAIL_DISABLED_TIME } from "../../../constants";
import { SectionContainer } from "../../styled/StyledComponents";
import { sendVerificationEmail } from "@services/auth";
import ResendEmail from "./ResendEmail";
import { useRouter } from "next/router";
import { AmptitudeEvents } from "@services/amptitude_events";
import {
  SEND_VERIFICATION_EMAIL_CLICKED,
  RESEND_VERIFICATON_EMAIL_BUTTON_CLICKED,
} from "@services/amptitude_contants";
const useStyles = makeStyles((theme) => ({
  // bgImage: {
  //   width: 20,
  //   height: 20,
  //   margin: "auto",
  //   background:
  //     "url('/static/images/backgrounds/vertification-email.png') center center no-repeat",
  // },

  root: {
    maxWidth: "452px",
    height: "550px",
    marginLeft: "15%",
  },

  title: {
    fontSize: 16,
    padding: "24px 0 45px",
    fontWeight: "500",
    textAlign: "left",
    maxWidth: "366px",
  },

  heading: {
    fontSize: "28px",
    fontWeight: "600",
    textAlign: "center",
    marginBottom: "24px",
  },

  resendButton: {
    width: "100%",
    borderRadius: "20px",
    color: "#e77128",
    borderColor: "#e77128",
    padding: "20px",
    "&:hover": {
      backgroundColor: "#e77128",
      borderColor: "white",
      color: "white",
    },
  },

  resendButton: {
    width: "100%",
    borderRadius: "20px",
    color: "#e77128",
    borderColor: "#e77128",
    padding: "20px",
    opacity: 1,
    pointerEvents: "auto",
    "&:hover": {
      backgroundColor: "#e77128",
      borderColor: "white",
      color: "white",
    },
  },

  resendSecondButton: {
    width: "100%",
    borderRadius: "20px",
    color: "#e77128",
    borderColor: "#e77128",
    padding: "20px",
    opacity: 0.6,
    pointerEvents: "none",
  },

  resendCount: {
    color: "#69CDAE",
    fontSize: "16px",
    fontWeight: "400",
    display: "flex",
    justifyContent: "center",
  },
}));

export default function EmailVertification({ user }) {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [second, setSecond] = useState(SEND_EMAIL_DISABLED_TIME);
  const [shouldCount, setShouldCount] = useState(true);
  const secondRef = useRef();
  secondRef.current = second;
  const router = useRouter();
  const [buttonActive, setButtonActive] = useState(false);
  const emailMinutes = Math.floor(second / 60);
  const emailSeconds = second - emailMinutes * 60;

  useEffect(() => {
    let interval;
    if (shouldCount) {
      interval = setInterval(() => {
        setSecond((second) => second - 1);
        if (second === 0) {
          clearInterval(interval);
          setButtonActive(true);
        }
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [shouldCount, second]);

  useEffect(() => {
    const onSendVerificationEmail = async (isResend) => {
      setIsLoading(true);
      setButtonActive(false);
      const response = await sendVerificationEmail(user?.email);
      const { isSuccess: verifySuccess, errorCode } = response || {};

      setIsLoading(false);
      if (verifySuccess) {
        if (isResend) {
          const response = await AmptitudeEvents(
            "User Registration",
            user?.id,
            RESEND_VERIFICATON_EMAIL_BUTTON_CLICKED
          );
          setShouldCount(true);
        } else {
          const response = await AmptitudeEvents(
            "User Registration",
            user?.id,
            SEND_VERIFICATION_EMAIL_CLICKED
          );
          setIsSuccess(true);
        }
      } else {
        if (errorCode === "USER-0013") {
          router.push("/login");
        }
      }
    };
    onSendVerificationEmail();
  }, []);

  const onSendVerificationEmail = async (isResend) => {
    setIsLoading(true);
    setButtonActive(false);
    const response = await sendVerificationEmail(user?.email);
    const { isSuccess: verifySuccess, errorCode } = response || {};

    setIsLoading(false);
    if (verifySuccess) {
      if (isResend) {
        setSecond(SEND_EMAIL_DISABLED_TIME);
        const response = await AmptitudeEvents(
          "User Registration",
          user?.id,
          RESEND_VERIFICATON_EMAIL_BUTTON_CLICKED
        );
        setShouldCount(true);
      } else {
        const response = await AmptitudeEvents(
          "User Registration",
          user?.id,
          SEND_VERIFICATION_EMAIL_CLICKED
        );
        setIsSuccess(true);
      }
    } else {
      if (errorCode === "USER-0013") {
        router.push("/login");
      }
    }
  };

  return (
    <>
      <SectionContainer className={classes.root}>
        <Box padding="50px">
          <Typography className={classes.heading}>Verify Your Email</Typography>
          <Box style={{ display: "flex", justifyContent: "center" }}>
            <img
              src="/static/svg/new_verify_check.svg"
              width={170}
              style={{ margin: "auto" }}
            />
          </Box>
          <Typography className={classes.title}>
            We sent a verification email to{" "}
            <span className="fw-bold" style={{ color: "#E77228" }}>
              {user?.email}
            </span>
            . Please tap the link inside that email to continue.
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            disabled={!buttonActive}
            onClick={() => onSendVerificationEmail({ isResend: true })}
            className={
              buttonActive ? classes.resendButton : classes.resendSecondButton
            }
          >
            Resend
          </Button>
          {shouldCount && second > 0 && (
            <Box className={classes.resendCount}>
              <div>
                <img
                  src="/static/svg/new_time_light.svg"
                  alt="resend icon"
                  width={16}
                />
                {`${emailMinutes.toString().padStart(2, "0")}:${emailSeconds
                  .toString()
                  .padStart(2, "0")}`}
              </div>
            </Box>
          )}
        </Box>
      </SectionContainer>
    </>
  );
}
